//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';

import Button, { IButtonProps } from '@components/atoms/button/Button';
import { ITrackableComponent } from '@utils/withTracking';
import { useOnboardingButtonStyles } from '@welcome-page/hooks/useOnboardingButtonStyles';

type Props = Omit<IButtonProps, 'buttonStyles'> & ITrackableComponent;

// TODO: PD-257587 - remove this component and replace its uses with one of the standard buttons
export const OnboardingButton = (props: Props) => {
  const styles = useOnboardingButtonStyles();
  return <Button buttonStyles={styles} {...props} />;
};
